<template>
    <CieloLayout layout-version="v1">
        <div class="invalid-url">
            <div class="invalid-url__container">
                <img class="invalid-url__img" src="@/assets/img/generic-error.svg" alt="" tabindex="-1" />
                <h1 class="invalid-url__title" v-text="$ml.get('invalidUrlTitle')" tabindex="0" />
                <p class="invalid-url__text" v-text="$ml.get('invalidUrlText')" tabindex="0" />
            </div>
        </div>
    </CieloLayout>
</template>

<script>
  const CieloLayout = () => import(
      /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
  );

  export default {
      components: {
          CieloLayout
      }
  };
</script>

<style lang="scss" scoped>
  .invalid-url {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1 0 auto;

      &__container {
          flex: 1 0 auto;
          text-align: center;
          max-width: 328px;
          
          @media screen and (min-width: 1025px) {
              max-width: 580px;
              flex: 0 0 auto;
          }
      }

      &__img {
          width: 200px;
          height: 200px;
          margin-bottom: 24px;
      }

      &__title {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 20px;
          font-weight: 700;
          color: #2F363E;
      }

      &__text {
          font-size: 16px;
          line-height: 24px;
          color: #5C6A7B;
          margin-bottom: 24px;
      }

      &__cta {
          width: 100%;

          @media screen and (min-width: 1025px) {
              max-width: 124px;
          }
      }
  }
</style>